import React from "react";
import { Table } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import CircularProgress from "@material-ui/core/CircularProgress";

const ReferralBonusTable = ({ referralBonusList, onSelectReferral, onStatusChange, isLoading }) => {
  return (
    <>
      <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
        <div className="tblmrgn mt-0">
          <div className="mt-5">
            <div>
              <Table hover responsive className="mb-0 default_table with_hoverbtn mrpdng_tbl">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Referral Bonus Coins</th>
                    <th>Referral Sign-Up User Bonus</th>
                    <th>Status</th>
                    <th className="wd-120">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan={5} className="text-center">
                        <div className="basic-verification-loader text-center">
                          <CircularProgress />
                        </div>
                      </td>
                    </tr>
                  ) : referralBonusList && referralBonusList.data && referralBonusList.data.length > 0 ? (
                    referralBonusList.data.map((referral, index) => (
                      <tr key={referral._id || index}>
                        <td>
                          <span className="f-w-500">
                            {index + 1}
                          </span>
                        </td>
                        <td>
                          <span className="f-w-500">{referral.referralBonusCoins} coins</span>
                        </td>
                        <td>
                          <span className="f-w-500">{referral.referralSignUpBonus} coins</span>
                        </td>
                        <td>
                          <span className={`btn badge ${referral.isActive ? 'badge-success' : 'badge-danger'}`} 
                          onClick={() => onStatusChange(referral)}>
                            {referral.isActive ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td>
                          <div className="d-flex">
                            <a
                              title="Edit"
                              className="btn btn-icon btn-light btn-hover-primary btn-sm mr-2"
                              onClick={() => onSelectReferral(referral)}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-primary">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")} />
                              </span>
                            </a>
                            
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5} className="text-center">
                        No Record Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReferralBonusTable;
